import React from "react";
import { Sheet, SheetContent } from "@/components/ui/sheet";

interface SheetWrapperProps {
  open: boolean;
  handleClose: any;
  width?: string;
  children: React.ReactNode;
  showCloseButton?: boolean;
}

export default function SheetWrapper({
  open,
  handleClose,
  width = "40vw",
  children,
  showCloseButton = true,
}: SheetWrapperProps) {
  return (
    <Sheet
      open={open}
      onOpenChange={(nextOpen) => {
        // Radix passes the new open state; only treat as close when transitioning to false.
        // Passing handleClose directly would also run if onOpenChange(true) ever fired.
        if (!nextOpen) handleClose();
      }}
    >
      <SheetContent
        style={{ width: width }}
        side="right"
        className="bg-transparent border-none shadow-none overflow-visible sheet"
        showCloseButton={showCloseButton}
      >
        <div className="my-2 h-full flex flex-col overflow-hidden rounded-3xl bg-white shadow-[0_8px_40px_rgba(15,23,42,0.1)] sheet-content">
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
}
